const TablerSvg = (props: { children: React.ReactNode; size?: number }) => (
  <svg
    width={props.size ?? 20}
    height={props.size ?? 20}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    {props.children}
  </svg>
);

const SortAscIcon = () => (
  <TablerSvg>
    <path d="M15 10v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4" />
    <path d="M19 21h-4l4 -7h-4" />
    <path d="M4 15l3 3l3 -3" />
    <path d="M7 6v12" />
  </TablerSvg>
);

const SortDescIcon = () => (
  <TablerSvg>
    <path d="M15 21v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4" />
    <path d="M19 10h-4l4 -7h-4" />
    <path d="M4 15l3 3l3 -3" />
    <path d="M7 6v12" />
  </TablerSvg>
);

const CheckIcon = () => (
  <TablerSvg>
    <path d="M5 12l5 5l10 -10" />
  </TablerSvg>
);

interface IProps {
  activeDirection: "asc" | "desc" | null;
  onApply: (direction: "asc" | "desc" | null) => void;
}

export const TableSortColumnPickerMenu = ({
  activeDirection,
  onApply,
}: IProps) => (
  <div className="table-sort-column-picker-menu" role="menu">
    {(["asc", "desc"] as const).map((d) => {
      const isChecked = activeDirection === d;
      const Icon = d === "asc" ? SortAscIcon : SortDescIcon;
      return (
        <button
          key={d}
          type="button"
          role="menuitemradio"
          aria-checked={isChecked}
          className="table-sort-column-picker-menu-item"
          data-checked={isChecked ? "" : undefined}
          onClick={() => onApply(isChecked ? null : d)}
        >
          <span className="table-sort-column-picker-menu-icon" aria-hidden>
            <Icon />
          </span>
          <span className="table-sort-column-picker-menu-label">
            {d === "asc" ? "Sort A-Z" : "Sort Z-A"}
          </span>
          <span
            className="table-sort-column-picker-menu-check"
            data-visible={isChecked ? "" : undefined}
            aria-hidden
          >
            {isChecked && <CheckIcon />}
          </span>
        </button>
      );
    })}
  </div>
);
